import { c as _c } from "react/compiler-runtime";
import { graphql, useMutation } from "@opensea/graphql";
import { AccountActions } from "../../stores/accountStore";
export const AcceptTermsMutation = graphql(`
  mutation AcceptTermsMutation($address: Address!) {
    acceptTerms(address: $address)
  }
`);
export function useAcceptTerms() {
  const $ = _c(4);
  const [, mutate] = useMutation(AcceptTermsMutation);
  let t0;
  if ($[0] !== mutate) {
    t0 = async variables => {
      const result = await mutate(variables);
      if (result.data?.acceptTerms) {
        AccountActions.setHasAcceptedTerms(true);
      }
      return result;
    };
    $[0] = mutate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const acceptTerms = t0;
  let t1;
  if ($[2] !== acceptTerms) {
    t1 = {
      acceptTerms
    };
    $[2] = acceptTerms;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}